export const standard = 'standard';
export const basic = 'basic';
export const important = 'important';
export const alt = 'alt';
export const basicAlt = 'basic-alt';
export const special = 'special';



// WEBPACK FOOTER //
// ./../src/Button/Types.js